/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { FRStep } from "@forgerock/javascript-sdk";
import FormLayout from "../../layout/form";
import styles from '../../../styles/SuspendedMessage.module.css';
import { getTextOutputCallBackByMessageType } from "../../../util/generalUtility";
// import { isNil } from "lodash";
import isNil from 'lodash/isNil';

interface Props {
  step: FRStep
}
export default function ({ step }: Props) {


  const getNextStep = () => {

    const nextStepMessageType1 = getTextOutputCallBackByMessageType(step, '0')?.getOutputByName('message', '');
    const nextStepMessageType4 = getTextOutputCallBackByMessageType(step, '4')?.getOutputByName('message', '');
    if (!isNil(nextStepMessageType1) && nextStepMessageType1.trim() !== '') {
      return (<div className={styles.subFrameNextSteps}>
        {step.getHeader() !== 'Error'?<h1 className={styles.nextStepHeading}>Next Steps</h1>:<></>}
        <div className={styles.steps}>
          <p className={styles.nextStepDescription} dangerouslySetInnerHTML={ {__html:nextStepMessageType1}}/>
        </div>
      </div>);
    }else if(!isNil(nextStepMessageType4) && nextStepMessageType4.trim() !== ''){
      return (<div className={styles.subFrameNextSteps}>
        <div className={styles.steps}>
          <p className={styles.nextStepDescription} dangerouslySetInnerHTML={ {__html:nextStepMessageType4}}/>
        </div>
      </div>);
    }else {
      <></>
    }

  }

  return (
    <FormLayout
      header={step.getHeader()}
      subHeader={step.getDescription()}
      button={<></>}>
      {getNextStep()}
      <br />
      {step.getHeader() !== 'Error' 
      ?
      <>
        <div className={styles.subFrameAssistance}>
        <h1 className={styles.assistanceHeading}>EngineWise® Connect Portal assistance</h1>
        <div className={styles.assistance}>
          <p className={styles.assistanceDescription}>For further assistance with EngineWise® Connect Portal, please contact the EngineWise® Connect Portal team at <a  href="mailto:gppwolsregistration@prattwhitney.com" target="_blank" style={{textDecoration:"none"}}>gppwolsregistration@prattwhitney.com</a>.</p>
        </div>
        </div>
        <br />
      </>
      :
      <>
      </>
      }

    </FormLayout>
  );
};
